import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';

import {ActionService} from "@/services/action.service";

import {ActionType} from '@/models/action.type';

import {Logger} from '@/util/logger';

import {ActivatedRoute, ParamMap, Router} from '@angular/router';

import {PanoramaService} from "@/services/panorama.service";

@Component({
  standalone: false,
  selector:    'pano-controls',
  templateUrl: 'panorama.controls.component.html'
})

/**
 *
 * @class PanoramaControlsComponent
 *
 * @brief the panoramic control bar
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class PanoramaControlsComponent implements OnInit, OnDestroy, AfterViewInit {

  public expanded: boolean = true;

  /** the lat to return to on the overwatch page (of the marker we clicked on */
  private _rx: number = 0.0;

  /** the lng to return to on the overwatch page (of the marker we clicked on */
  private _ry: number = 0.0;

  /** the zoom level to return to on the overwatch page */
  private _rz: number = 0.0;

  @Output() expanded_event = new EventEmitter<boolean>();

  /**
   * standard constructor
   *
   * @param router  in case we need to redirect the page
   * @param actions the GUI actions we can invoke
   * @param route   the current URL
   * @param panos   the panoramas service
   *
   */
  constructor(
    private router: Router,
    private actions: ActionService,
    private route: ActivatedRoute,
    private panos: PanoramaService
  ) {

  }

  /* on creation subscribe to the alert service, so we get updates when alerts happen from anywhere */
  ngOnInit() {

    Logger.debug('[PanoramaControlsComponent] init...');

    const params: ParamMap    = this.route.snapshot['queryParamMap'];

    if (params.has('rx')) {

      this._rx = Number(params.get('rx'));
    }

    if (params.has('ry')) {

      this._ry = Number(params.get('ry'));
    }

    if (params.has('rz')) {

      this._rz = Number(params.get('rz'));
    }
  }

  ngAfterViewInit() {


  }

  /* clean up at the end */
  ngOnDestroy() {


  }

  toggleAction() {

    Logger.debug('[PanoramaControlsComponent] toggling...');

    if (this.expanded) {

      this.expanded = false;

      this.expanded_event.emit(this.expanded);

    } else {

      this.expanded = true;

      this.expanded_event.emit(this.expanded);
    }
  }

  backAction() {

    Logger.debug(`[PanoramaControlsComponent] jumping to overwatch `);

    this.actions.action(ActionType.PANO_NAVIGATE_BACK).execute();

  }

  linkAction() {

    Logger.debug('[PanoramaControlsComponent] creating link...');
  }

  mapAction() {

    Logger.debug('[PanoramaControlsComponent] toggling map...');

    this.actions.action(ActionType.PANO_TOGGLE_MAP).execute();
  }

  leftAction() {

    this.actions.action(ActionType.PANO_LEFT).execute();
  }

  upAction() {

    this.actions.action(ActionType.PANO_UP).execute();
  }

  downAction() {

    this.actions.action(ActionType.PANO_DOWN).execute();
  }

  rightAction() {

    this.actions.action(ActionType.PANO_RIGHT).execute();
  }

  resetAction() {
    this.actions.action(ActionType.PANO_RESET).execute();
  }

  zoomInAction() {

    this.actions.action(ActionType.PANO_ZOOM_IN).execute();
  }

  zoomOutAction() {

    this.actions.action(ActionType.PANO_ZOOM_OUT).execute();
  }

  fullScreenAction() {

    this.actions.action(ActionType.PANO_TOGGLE_FULLSCREEN).execute();
  }

  filterAction() {

    Logger.debug('[PanoramaControlsComponent] filtering...');

    this.actions.action(ActionType.PANO_SELECTOR_TOGGLE).execute();
  }
}
